var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTmview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1195.317px",
    height: "303.703px",
    viewBox: "2.341 597.488 1195.317 303.703",
    enableBackground: "new 2.341 597.488 1195.317 303.703",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.777,597.488l-83.631,216.041l-83.118-216.041H2.341v46.722h88.771v252.295h51.393V644.21h98.114v252.295h51.393 V711.301c0-5.747-0.934-12.333-1.027-17.753l77.139,202.957h39.059l77.698-203.146c0,5-1.309,10.886-1.309,15.651v187.493h51.393 V597.488H472.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919396",
    d: "M677.889,896.505l-65.41-168.197h15.929l43.688,115.264c5.795,14.716,10.136,29.573,13.08,38.918h0.937 c4.25-14.019,8.598-27.378,13.078-39.198l43.688-114.982h15.883l-65.41,168.197L677.889,896.505L677.889,896.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919396",
    d: "M773.707,682.053c0-9.968,3.273-14.947,9.816-14.947c3.006-0.101,5.854,1.365,7.521,3.875 c1.996,3.315,2.945,7.16,2.707,11.026c0.207,3.861-0.736,7.699-2.707,11.025c-1.606,2.595-4.469,4.143-7.521,4.064 C776.98,697.13,773.707,692.113,773.707,682.053z M791.934,896.505h-14.02V728.308h14.02V896.505z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919396",
    d: "M905.047,901.177c-24.578,0-43.734-7.567-57.473-22.705c-13.732-15.139-20.603-36.351-20.603-63.637 c0-26.972,6.634-48.572,19.904-64.803c13.047-16.136,32.945-25.163,53.682-24.34c18.08-0.807,35.492,6.908,47.05,20.836 c11.491,14.017,17.194,32.705,17.194,56.625v14.018H843.322c0,23.362,5.608,40.276,16.264,52.517 c10.652,12.241,25.838,17.987,45.646,17.987c8.825,0.039,17.649-0.698,26.35-2.196c9.707-2.468,19.283-5.433,28.688-8.875v14.018 c-8.776,3.841-17.963,6.677-27.381,8.453C923.688,900.597,914.367,901.302,905.047,901.177z M900.373,739.428 c-14.867-0.429-29.182,5.644-39.199,16.632c-9.859,10.746-15.604,23.596-17.285,46.954H948.4c0-18.688-4.252-35.463-12.752-46.72 c-8.297-10.945-21.363-17.209-35.091-16.823L900.373,739.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919396",
    d: "M1135.617,896.505l-37.004-112.131c-2.384-7.664-5.47-18.688-9.349-32.705h-0.936l-3.271,11.306 l-7.002,21.634l-37.473,111.896h-15.045l-48.591-168.197h16.49l27.056,99.328c5.143,18.048,9.301,36.357,12.471,54.854h0.936 c3.396-16.84,7.855-33.444,13.361-49.713l34.859-104.469h14.014l33.123,104.328c7.479,24.39,12.012,40.509,13.688,49.854h0.935 c0.846-9.345,5-26.307,12.434-55.646l25.787-98.535h15.558l-45.974,168.197H1135.617z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572.153,
    y: 600.57,
    fill: "#CFD0D1",
    width: 5.232,
    height: 299.158
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F509A",
    d: "M472.777,597.488l-83.631,216.041l-83.118-216.041H2.341v46.722h88.771v252.295h51.393V644.21h98.114 v252.295h51.393V711.301c0-5.747-0.934-12.333-1.027-17.753l77.139,202.957h39.059l77.698-203.146c0,5-1.309,10.886-1.309,15.651 v187.493h51.393V597.488H472.777z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmview);
export default __webpack_public_path__ + "static/media/tmview.33c0138840c875512ce814887cca22ac.svg";
export { ForwardRef as ReactComponent };